import React from 'react';

export const thumbnailElementId = 'journey-thumbnail-node';

export const shareThumbnailCodeGetTemplate = (target: string, imageSrc: string) => (
  <div id={thumbnailElementId} style={{ display: 'inline-flex', flexDirection: 'column' }}>
    <a
      href={target}
      target='_blank'
      rel='noopener noreferrer'
      style={{ color: '#101010', fontWeight: 600, fontSize: 14, lineHeight: '157%' }}
    >
      View Journey
    </a>
    <a href={target} target='_blank' rel='noopener noreferrer' style={{ marginTop: 8 }}>
      <img src={imageSrc} height='auto' alt='Journey Thumbnail' style={{ maxWidth: 336, borderRadius: 8 }} />
    </a>
  </div>
);
